import { useCallback, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TAB_BASIC, TAB_BUDGET, TAB_FAVORITE } from '../constants';

/**
 * useTab
 * - URL Query Parameter로 tab 상태 관리
 * - 초기 접속 시 기본값 설정
 * - 유효성 검사 포함
 */
const useTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // URL에서 tab 읽기 (tab이 없으면 BUDGET이 기본값)
  const tab = useMemo(() => {
    const tabFromUrl = searchParams.get('tab');
    const validTabs = [TAB_BASIC, TAB_BUDGET, TAB_FAVORITE];
    if (tabFromUrl && validTabs.includes(tabFromUrl)) {
      return tabFromUrl;
    }
    return TAB_BUDGET;
  }, [searchParams]);

  // tab이 URL에 없으면 tab=BUDGET으로 리디렉션
  useEffect(() => {
    const tabFromUrl = searchParams.get('tab');
    const validTabs = [TAB_BASIC, TAB_BUDGET, TAB_FAVORITE];

    if (tabFromUrl === TAB_BUDGET || (tabFromUrl && !validTabs.includes(tabFromUrl))) {
      const params = new URLSearchParams();
      setSearchParams(params, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  // tab 변경 시 URL 업데이트 (다른 query parameter들 모두 초기화)
  const setTab = useCallback(
    newTab => {
      const params = new URLSearchParams();
      if (newTab !== TAB_BUDGET) {
        params.set('tab', newTab); // BASIC도 포함하여 tab 명시
      }
      // tab만 남기고 나머지 query들은 모두 제거 (BUDGET이면 쿼리 제거)
      setSearchParams(params);
    },
    [setSearchParams]
  );

  return { tab, setTab };
};

export default useTab;
